module.exports = __webpack_public_path__ + "img/Girl-Barrel.feb7cee7.png";